import { makeGrpcQueryClient, makeGrpcTransport } from "@/utils/connect-query/connect-client";
import { useMemo } from "react";

export function useNetworkingClients(grpcApiHost: string) {
  const grpcTransport = useMemo(() => makeGrpcTransport(grpcApiHost), [grpcApiHost]);
  const grpcQueryClient = useMemo(() => makeGrpcQueryClient(), []);

  return { grpcTransport, grpcQueryClient };
}
